import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import topImage from "../../../assets/images/BannerTop.png";
import "./meal.css"; // 스타일 파일 필요

export const Meal = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const [meal, setMeal] = useState(null); // 식단 데이터
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 1. 관리자 체크
        const token = localStorage.getItem("token");
        if (token) setIsAdmin(true);

        // 2. 최신 소식지 가져오기
        const fetchMeal = async () => {
            try {
                const res = await fetch(`${BOARD_URL}/meals/latest`);
                const data = await res.json();
                if (data) setMeal(data);
            } catch (err) {
                console.error("소식지 로드 실패:", err);
            }
        };
        fetchMeal();
    }, [BOARD_URL]);

    // 삭제 핸들러
    const handleDelete = async () => {
        if (!window.confirm("현재 소식지를 삭제하시겠습니까?")) return;
        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${BOARD_URL}/meals/${meal._id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                alert("삭제되었습니다.");
                setMeal(null); // 화면에서 즉시 제거
            }
        } catch (err) {
            alert("오류 발생");
        }
    };

    return(
        <>
            <Navbar />
            <Banner imageSrc={topImage} title="소식지" />
            
            <div className="page" style={{ padding: '50px 20px', textAlign: 'center' }}>
                
                {/* 관리자용 버튼 영역 */}
                {isAdmin && (
                    <div className="admin-controls" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px', maxWidth: '800px', margin: '0 auto 20px' }}>
                        <Link to="/meal/MealWrite">
                            <button style={{ padding: '8px 15px', backgroundColor: '#898989', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                새 소식지 등록
                            </button>
                        </Link>
                        {meal && (
                            <button onClick={handleDelete} style={{ padding: '8px 15px', backgroundColor: '#ff6b6b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                삭제
                            </button>
                        )}
                    </div>
                )}

                {/* 소식지 보여주는 영역 */}
                {meal ? (
                    <div className="meal-content">
                        <header className="month" style={{ marginBottom: '20px' }}>
                            <div className="month-text" style={{ fontSize: '2rem', fontWeight: 'bold', color: '#333' }}>
                                {meal.month}
                            </div>
                        </header>
                        <div className="top-title-line" style={{ maxWidth: '800px', margin: '0 auto' }}>
                            <img 
                                src={meal.imageUrl}
                                alt="소식지 이미지" 
                                style={{ width: '100%', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
                            />
                        </div>
                    </div>
                ) : (
                    // 등록된 소식지가 없을 때
                    <div style={{ padding: '100px 0', color: '#888' }}>
                        <h3>등록된 소식지가 없습니다.</h3>
                        {isAdmin && <p>관리자님, 새 소식지를 등록해주세요.</p>}
                    </div>
                )}
            </div>
            
            <Footer />
        </>
    );
}